import { useSeo } from "@/hooks/useSeo";
import { PageHero } from "@/components/common/PageHero";
import { StandardsSection } from "@/components/approach/StandardsSection";
import { InquiryJourney } from "@/components/approach/InquiryJourney";
import { KnowledgeMapSection } from "@/components/approach/KnowledgeMapSection";
import { ProgressionSection } from "@/components/approach/ProgressionSection";
import { AssessmentSection, BrandStatement } from "@/components/approach/AssessmentSection";

export default function Approach() {
  useSeo("Our Approach", "MUCCI Academy's approach: standards-informed, inquiry-driven, project-based learning that connects Science, Social Studies & Humanities, Engineering & Design and Critical Thinking.");
  return (
    <div data-testid="approach-page">
      <PageHero testid="approach-hero" eyebrow="Our Approach" color="bg-lavender" title="Learning Beyond Subjects. Thinking Beyond Boundaries."
        intro="Real questions rarely fit inside one subject. At MUCCI Academy, students explore them by bringing science, social studies, engineering and critical thinking together, so knowledge turns into real understanding.">
        <p className="mt-8 inline-flex flex-wrap items-center gap-x-3 gap-y-1 rounded-2xl sm:rounded-full bg-white/80 px-5 py-2.5 font-heading text-base font-medium sm:text-lg" data-testid="approach-positioning">
          Standards-Aligned <span aria-hidden="true">·</span> Inquiry-Driven <span aria-hidden="true">·</span> Project-Based <span aria-hidden="true">·</span> Growth Mindset
        </p>
      </PageHero>
      <KnowledgeMapSection />
      <StandardsSection />
      <InquiryJourney />
      <ProgressionSection />
      <AssessmentSection />
      <BrandStatement />
    </div>
  );
}
